import { render } from "./com-worker-add.vue?vue&type=template&id=400176d0"
import script from "./com-worker-add.vue?vue&type=script&lang=js"
export * from "./com-worker-add.vue?vue&type=script&lang=js"
script.render = render

export default script